// src/features/platform/mapStatusToVariant.ts

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'secondary';

export function mapPlatformStatusToVariant(status?: string): BadgeVariant {
  if (!status) return 'secondary';
  if (status.includes('ACTIVE')) return 'success';
  if (status.includes('PENDING')) return 'warning';
  if (status.includes('SUSPENDED')) return 'error';
  if (status.includes('MAINTENANCE')) return 'info';
  if (status.includes('ARCHIVED') || status.includes('DELETED')) return 'secondary';
  return 'secondary';
}

export function mapMemberStatusToVariant(status?: string): BadgeVariant {
  if (!status) return 'secondary';
  if (status.includes('ACTIVE')) return 'success';
  if (status.includes('SUSPENDED')) return 'error';
  if (status.includes('INVITED')) return 'warning';
  if (status.includes('REMOVED')) return 'secondary';
  return 'secondary';
}

export function mapRoleToVariant(role?: string): BadgeVariant {
  if (!role) return 'secondary';
  if (role.includes('OWNER')) return 'error';
  if (role.includes('ADMIN')) return 'warning';
  if (role.includes('MANAGER')) return 'info';
  if (role.includes('MEMBER')) return 'success';
  if (role.includes('VIEWER')) return 'secondary';
  return 'secondary';
}

export function mapInvitationStatusToVariant(status?: string): BadgeVariant {
  if (!status) return 'secondary';
  if (status.includes('PENDING')) return 'warning';
  if (status.includes('ACCEPTED')) return 'success';
  if (status.includes('DECLINED')) return 'error';
  if (status.includes('EXPIRED') || status.includes('REVOKED')) return 'secondary';
  return 'secondary';
}

export function mapProductStatusToVariant(status?: string): BadgeVariant {
  if (!status) return 'secondary';
  if (status.includes('ENABLED')) return 'success';
  if (status.includes('DISABLED')) return 'secondary';
  if (status.includes('COMING_SOON')) return 'info';
  if (status.includes('BETA')) return 'warning';
  if (status.includes('DEPRECATED')) return 'error';
  return 'secondary';
}

export function mapFederationStatusToVariant(status?: string): BadgeVariant {
  if (!status) return 'secondary';
  if (status.includes('ACTIVE') || status.includes('HEALTHY')) return 'success';
  if (status.includes('PENDING') || status.includes('DEGRADED')) return 'warning';
  if (status.includes('SUSPENDED') || status.includes('ERROR') || status.includes('UNREACHABLE')) return 'error';
  if (status.includes('REVOKED')) return 'secondary';
  return 'secondary';
}

export function mapTrustLevelToVariant(level?: string): BadgeVariant {
  if (!level) return 'secondary';
  if (level.includes('FULL')) return 'success';
  if (level.includes('RESOURCE_LINK')) return 'info';
  if (level.includes('IDENTITY')) return 'warning';
  if (level.includes('CATALOG_ONLY')) return 'secondary';
  return 'secondary';
}

export function formatStatus(status?: string): string {
  if (!status) return 'Unknown';
  return status
    .replace(/^(PLATFORM_STATUS_|PLATFORM_MEMBER_STATUS_|PLATFORM_INVITATION_STATUS_|PLATFORM_PRODUCT_STATUS_|FEDERATION_PEER_STATUS_|FEDERATION_TRUST_LEVEL_|FEDERATION_HEALTH_STATUS_|DATA_RESIDENCY_LEVEL_|CONSENT_STATUS_|PLATFORM_ROLE_)/, '')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase());
}
